export default {
  lang: {
    reset: 'รีเซ็ต',
    search: 'การคัดกรอง',
    expand: 'ขยาย',
    collapse: 'เก็บไว้',
  },
};
